import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'
import SettingsIcon from '@material-ui/icons/Settings'

import { routingConstants } from 'constants/routingConstants'

import Title from 'components/CommonUI/Title/Title'
import Button from 'components/CommonUI/Button/Button'

const PageHeader = () => {
  const history = useHistory()

  const handleClickManageDevices = () => {
    history.push(routingConstants.devicesManagement)
  }

  return (
    <div className="page_header_container">
      <Title
        title="Device connection"
        component="h1"
        className="page_header_title"
      />
      <Button
        variant="text"
        className="manage_device_button"
        startIcon={<SettingsIcon />}
        onClick={handleClickManageDevices}
      >
        Manage devices
      </Button>
    </div>
  )
}

export default memo(PageHeader)
